import { Injectable } from '@angular/core';
import { LMCommonUtilService } from '@app/utils';

@Injectable()
export class LMSimpleProgressService {
  
  constructor(private lmCommonUtil: LMCommonUtilService) { }

  /**
   * Converts value to a percentage for bar width
   * @returns
   */
  public getWidth(lmProgressFieldData: LMProgressFieldData): number {
    const rangeValue = lmProgressFieldData.meterRangeValue ? lmProgressFieldData.meterRangeValue : 100;
    const value = Number(lmProgressFieldData.field.value);

    if (lmProgressFieldData.field.value as number > 1) {
      return (value / rangeValue) * 100;
    } else if (lmProgressFieldData.field.value as number <= 1) {
      return value * 100;
    } else {
      return value;
    }
  }

  /**
   * Value to be displayed after HTML has been rendered
   * @param lmProgressFieldData
   */
  public getDisplayValue(lmProgressFieldData: LMProgressFieldData): string {
    return lmProgressFieldData.displayPercent ? lmProgressFieldData.value.toString() + '%' : lmProgressFieldData.value.toString();
  }

  /**
   * Used to set title attribute for tooltip
   * @param lmProgressFieldData
   */
  public getTitle(lmProgressFieldData: LMProgressFieldData): string {
    return this.getDisplayValue(lmProgressFieldData) + ' of ' + this.getRangeText(lmProgressFieldData);
  }

  /**
   * Gets color class based on value,
   * sets background color of progress bar
   * @param lmProgressFieldData
   */
  public getColorClass(lmProgressFieldData: LMProgressFieldData): string {
    const color = this.lmCommonUtil.getRangeColor(lmProgressFieldData.ranges, Number(lmProgressFieldData.field.value), lmProgressFieldData.dataView);
    return 'lm-completed lm-' + color;
  }

  /**
   * Sets inverse class if width is greater than 55%
   * @param lmProgressFieldData
   */
  public getInverseClass(lmProgressFieldData: LMProgressFieldData): string {
    if (this.getWidth(lmProgressFieldData) > 55) {
      return 'lm-inverse';
    }

    return '';
  }

  private getRangeText(lmProgressFieldData: LMProgressFieldData) {
    return lmProgressFieldData.meterRangeValue ?  lmProgressFieldData.meterRangeValue : '100';
  }
}
